/*
 * @Author: your name
 * @Date: 2021-11-24 10:48:45
 * @LastEditTime: 2021-11-29 17:21:52
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: /static-pc/src/store/module/demand/action.js
 */
import * as Types from '../../mutations-types'
import * as DemandService from '@/services/demandService'
export default {
  getSearchDemandList ({commit, state},req) {
    return DemandService.getSearchDemandList(req).then(res=>{
      commit(Types.GET_SEARCH_DEMAND_LIST,res.data.records)
      return Promise.resolve(res.data.totals)
    },rea=>{
      return Promise.reject(rea)
    })
  },
  getDemandDetail ({commit, state}, demandId) {
    return DemandService.getDemandDetail(demandId).then(res=>{
      return Promise.resolve(res.data)
    },rea=>{
      return Promise.reject(rea)

    })
  },
  getRecommendDemandList ({commit, state}) {
    return DemandService.getRecommendDemandList().then(res=>{
      return Promise.resolve(res.data)
    },rea=>{
      return Promise.reject(rea)

    })
  },
}